import PropTypes from 'prop-types'
import { MajorEventsLandingQuery, MAJOR_EVENTS_LANDING_QUERY } from '@layouts/major-events-landing'
import { fetchSSRData } from '@lib/ssr-fetch'

function MajorEventsLandingPage(props) {
  const { data: ssrData, ...restProps } = props
  return <MajorEventsLandingQuery {...restProps} ssrData={ssrData} />
}

MajorEventsLandingPage.propTypes = {
  data: PropTypes.object,
}

MajorEventsLandingPage.getInitialProps = async ({ query }) => fetchSSRData({
  query,
  graphqlQuery: MAJOR_EVENTS_LANDING_QUERY,
  variables: query,
  transform: (data) => data?.majorEventsLandingCollection?.items?.[0],
})

export default MajorEventsLandingPage
